import styled from 'styled-components';

const StyledButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  transition: opacity 0.3s linear;

  .icon {
    margin: -2em 1ch -2em 0;
  }
`;

export default StyledButtonContent;
